<app-side-menu>
  
  <div class="departments-table">
    <app-table
      [title]="'Lista de Departamentos'"
      [data]="departments"
      [columns]="columns"
      [loading]="loading"
      [showSearch]="true"
      [searchPlaceholder]="'Pesquisar departamentos...'"
      [clickable]="true"
      [disablePagination]="false"
      [totalItemsFromBackend]="totalItems"
      [actions]="actions"
      [enableSorting]="true"
      (searchChange)="onSearchChange($event)"
      (rowClick)="viewDepartment($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (sortChange)="onSortChange($event)">
      <div table-header-action class="d-flex gap-2">
        <button class="btn btn-outline-secondary btn-sm" (click)="exportToCSV()">
          <i class="fas fa-file-csv me-1"></i> Exportar CSV
        </button>
        <button
          *appHasPermission="'Departments.Manage'"
          class="btn btn-primary btn-sm"
          (click)="newDepartment()">
          <i class="fas fa-plus me-1"></i> Novo Departamento
        </button>
      </div>
    </app-table>
  </div>

  <!-- Modal de Gerenciar Gerente -->
  <app-modal
    [isOpen]="showAssignManagerModal"
    [title]="'Gerenciar Gerente do Departamento'"
    [size]="'md'"
    (close)="closeAssignManagerModal()">
    
    <app-loading [show]="isLoadingStaff" message="Carregando funcionários..."></app-loading>
    
    <form [formGroup]="assignManagerForm" (ngSubmit)="onSubmitAssignManager()" *ngIf="!isLoadingStaff && selectedDepartment">
      <div class="mb-3">
        <label class="form-label">
          Departamento
        </label>
        <p class="form-control-plaintext fw-bold">{{ selectedDepartment.name }}</p>
        <small class="form-text text-muted" *ngIf="selectedDepartment.description">
          {{ selectedDepartment.description }}
        </small>
      </div>

      <div class="mb-3">
        <label for="managerStaffId" class="form-label">
          Gerente
        </label>
        <select
          id="managerStaffId"
          class="form-control"
          formControlName="managerStaffId"
          [class.is-invalid]="isManagerFieldInvalid()">
          <option [value]="">Selecione um gerente...</option>
          <option *ngFor="let staff of staffMembers" [value]="staff.Id">
            {{ staff.FullName }} - {{ staff.Registration }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isManagerFieldInvalid()">
          {{ getManagerFieldError() }}
        </div>
        <small class="form-text text-muted">
          Selecione o funcionário que será o gerente deste departamento.
        </small>
      </div>

      <div class="modal-footer-buttons">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div>
            <button
              *ngIf="hasManager()"
              type="button"
              class="btn btn-danger"
              (click)="onRemoveManager()"
              [disabled]="isSubmittingManager">
              <span *ngIf="isSubmittingManager" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isSubmittingManager" class="fas fa-user-times me-2"></i>
              {{ isSubmittingManager ? 'Removendo...' : 'Desatribuir Gerente' }}
            </button>
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="closeAssignManagerModal()"
              [disabled]="isSubmittingManager">
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="isSubmittingManager || assignManagerForm.invalid">
              <span *ngIf="isSubmittingManager" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isSubmittingManager" class="fas fa-save me-2"></i>
              {{ isSubmittingManager ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </app-modal>

</app-side-menu>

